export default "__VITE_ASSET__gZ44HfVV__"